/**
 * Object Loader
 * @author David <david.prenninger@gmx.de>
 *
 * This file provides all helper functions related to model loading from woocommerce.
 */
import { STLLoader } from './STLLoader';

const loader = new STLLoader();

const loadObjectFromWoocommerce = (
  store,
  fileName,
  modelName,
  finishCallback,
  progressCallback,
) => {
  loader.load(fileName, (geometry) => {
    const outObject = {};
    outObject[modelName] = geometry;
    store.dispatch('addModel', outObject);
    finishCallback();
  }, progressCallback);
};

export default {
  loadFromProductList(store) {
    store.getters.products.forEach((product) => {
      if (product.type) {
        loadObjectFromWoocommerce(store, product.model, product.id, () => {}, () => {});
        if (product.modelB) {
          loadObjectFromWoocommerce(store, product.modelB, `${product.id}_B`, () => {}, () => {});
        }
      }
    });
  },
};
